import io from 'socket.io-client';
import dotend from 'dotenv';
dotend.config();

class SocketClient {
    constructor() {
        this.client = io(process.env.REACT_APP_SOCKET_URL).connect();
    }
}
export let socketClient = new SocketClient();
